import React, { useState, useEffect } from "react";
import { getAdjacentTechnologies } from "./api";
import AdjacentTechnology from "./AdjacentTechnology";
import CLRSelect from "./CLRSelect";
import TechForm from "./TechForm";
import { Modal } from "./Modal";
import "./index.css";

function App() {
  const [comparisonTechName, setComparisonTechName] = useState("");
  const [adjacentTechs, setAdjacentTechs] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [clr, setClr] = useState("B");

  const [selectedTech, setSelectedTech] = useState(null);

  const handleClrChange = (e) => {
    setClr(e.target.value);
  };

  const layout = (data) => {
    const totalTech = data.length;
    const radius = 40; // Radius as a percentage of the container
    const angleStep = (2 * Math.PI) / totalTech;

    return data.map((tech, index) => {
      const angle = index * angleStep - Math.PI / 2;
      const x = 50 + radius * Math.cos(angle);
      const y = 50 + radius * Math.sin(angle);

      return {
        ...tech,
        position: {
          left: `${x}%`,
          top: `${y}%`,
        },
      };
    });
  };

  const fetchAdjacentTechnologies = async (comparisonTechName) => {
    setLoading(true);
    setError(null);

    try {
      const { techs } = await getAdjacentTechnologies(comparisonTechName);
      const filteredTechs = techs.filter(
        (tech) => tech.naive_substitutability > 5
      );
      const laidOutTechs = layout(filteredTechs);
      setAdjacentTechs(laidOutTechs);
    } catch (error) {
      console.error("Error fetching adjacent technologies:", error);
      setError("Failed to fetch adjacent technologies. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (comparisonTechName) fetchAdjacentTechnologies(comparisonTechName);
  }, [comparisonTechName]);

  const handleAnalysis = (tech, analysis) => {
    setAdjacentTechs((prev) =>
      prev.map((t) => (t.name === tech.name ? { ...t, ...analysis } : t))
    );
  };

  return (
    <div className="App min-h-screen flex flex-col items-center justify-center bg-gray-100 relative">
      {error && (
        <Modal show={!!error} onClose={() => setError(null)}>
          <p className="text-red-500 text-2xl font-bold">Error</p>
          <p className="mt-4 text-gray-700">{error}</p>
        </Modal>
      )}

      {/* <CLRSelect
        className="absolute top-4 right-4 text-xs opacity-50 hover:opacity-100 z-50"
        value={clr}
        onChange={handleClrChange}
      /> */}

      <TechForm
        onSubmit={setComparisonTechName}
        loading={loading}
        error={error}
        comparisonTechName={comparisonTechName}
      />

      {adjacentTechs && !loading && (
        <div className="absolute inset-20 top-30 z-1">
          {adjacentTechs.length > 0 ? (
            adjacentTechs.map((tech, index) => (
              <AdjacentTechnology
                key={index}
                animationDelay={index * 0.1}
                comparisonTechName={comparisonTechName}
                tech={tech}
                onAnalysis={handleAnalysis}
                clr={clr}
                selectedTech={selectedTech}
                setSelectedTech={setSelectedTech}
              />
            ))
          ) : (
            <p>No adjacent technologies found.</p>
          )}
        </div>
      )}
    </div>
  );
}

export default App;
